import React from "react";
import { getVendorSettings } from "../../../services/helper";

export default function ReportPrintHeader({ title }) {
  const vendor_email = getVendorSettings("email");
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_phone = getVendorSettings("vendor_contact_phone");

  return (
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      <h2 style={{ margin: 0 }}>{vendor_store_name}</h2>
      <p style={{ margin: 0 }}>{vendor_address}</p>
      <p style={{ margin: 0 }}>
        {vendor_phone} | {vendor_email}
      </p>
      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>{title}</h3>
      <hr />
    </div>
  );
}
